import { Toast } from "antd-mobile";
import { useRef } from "react";
import styles from "./index.module.scss";
// import { useCountDown } from 'ahooks';

type Props = {
  upload: (file: File) => Promise<void> | undefined;
  code: number[];
};

export const FaceVideo = ({ upload, code = [] }: Props) => {
  // const [_, formattedRes] = useCountDown({
  //     leftTime: logic.time,
  //     onEnd: logic.finish
  // });
  const inputRef = useRef<any>();
  // const { minutes, seconds } = formattedRes;
  const onFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    const file: File = (target.files as FileList)[0];
    if (!file || (file.size as number) === 0) {
      Toast.show("请选择认证视频");
    } else {
      const result = await upload(file);
      // if(!result){
      //     e.target.files = [];
      // }else{

      // }
    }
  };
  function isIOS() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  }

  return (
    <div className={styles.scan_face}>
      <div className={styles.scan_face_title}>人脸识别</div>
      <div className={styles.scan_face_content}>
        <div className={styles.scan_face_bg}>
          {
            isIOS() ? <input
                type={"file"}
                onChange={(e) => onFileChange(e)}
                multiple={false}
                accept="video/*"
                className={styles.fileSelect}
                ref={inputRef}
          /> :<input
              type={"file"}
              onChange={(e) => onFileChange(e)}
              multiple={false}
              accept="video/*"
              className={styles.fileSelect}
              ref={inputRef}
              //@ts-ignore
              capture="camcorder"
            />
          }
        </div>
      </div>
      {/* <div className={styles.countdown}> */}

      {/* {minutes < 0 ? `0${minutes}` : minutes}:{seconds}&nbsp;秒后刷新
            </div> */}
      <div className={styles.scan_face_tip}>
        <div>1.请确认由本人亲自操作；</div>
        <div>
          2.请将脸置于提示框内，证件放在下颚，并按提示
          <span className={styles.scan_face_tip_text}>
            读出数字: {code.join("")}。
          </span>
        </div>
        <div>3.视频长度最长10秒，且大小不超过40M。</div>
      </div>

      <div className={styles.scan_face_steps}>
        <div className={styles.scan_face_1}>
          <div className={styles.scan_face_step_icon}></div>
          <div className={styles.scan_face_step_text}>正对手机</div>
        </div>
        <div className={styles.scan_face_2}>
          <div className={styles.scan_face_step_icon}></div>
          <div className={styles.scan_face_step_text}>光线充足</div>
        </div>
        <div className={styles.scan_face_3}>
          <div className={styles.scan_face_step_icon}></div>
          <div className={styles.scan_face_step_text}>放慢动作</div>
        </div>
      </div>
    </div>
  );
};
